module.exports = __webpack_public_path__ + "static/media/Illuminate.dca7fd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Illuminate.jpg
// module id = 1615
// module chunks = 0